import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../../http/http-client.service';
import { CMSSessionService } from '../../session/cms-session.service';
import { environment } from 'apps/portal/src/environments/environment';

export interface AuthToken {
  access_token: string;
  expires_in: number;
  token_type: string;
}

@Injectable({
  providedIn: 'root',
})
export class CMSSettingsContentService extends HttpClientService {
  public host;

  constructor(
    public http: HttpClient,
    private cmsSessionService: CMSSessionService
  ) {
    super(http);
  }

  return(schema: string): Observable<any> {
    const url =
      environment.configSite.endPointAPI +
      environment.configSite.endPointAPP +
      schema;

    const token = this.cmsSessionService.getSettingsToken();

    const headerSettings: { [name: string]: string | string[] } = {};
    const headerENUM = { AUTH: 'Authorization', CONTENT_TYPE: 'Content-Type' };

    headerSettings[headerENUM.AUTH] = token;
    headerSettings[headerENUM.CONTENT_TYPE] = 'application/json; charset=utf-8';
    const httpHeaders = new HttpHeaders(headerSettings);

    return this.get(url, null, '', '', httpHeaders);
  }
}
